export default __webpack_public_path__ + "static/media/loading_animation.c09ba53f.gif";